import React from "react";
import SearchForm from "../../Common/SearchForm";
import { connect } from "react-redux";
import {
  updateExportStatusHistoryQuery,
  updateExportDestinationHistoryQuery,
} from "../../Store/mutations";
import ToastContainer from "../../components/Toast/ToastContainer";

export const ExportHistorySearchForm = ({
  configurationIds,
  configurationNames,
  updateExportDestinationHistoryQuery,
  updateExportStatusHistoryQuery,
  selectedDestination,
  selectedStatus,
}) => {
  return (
    <>
      <SearchForm id="exportControl" title={`Export Control`}>
        <label>Export Destination</label>
        <select
          aria-label="select destination"
          defaultValue={selectedDestination}
          onChange={({ target }) => {
            updateExportDestinationHistoryQuery(target.value);
          }}
        >
          <option disabled value="default">
            Choose destination
          </option>
          <option value="all">All</option>
          {configurationIds.map((id) => {
            const hasName =
              configurationNames &&
              typeof configurationNames === "object" &&
              configurationNames[id] &&
              typeof configurationNames[id] === "string" &&
              configurationNames[id].trim() !== "";

            return (
              <option value={id} key={id}>
                {hasName ? configurationNames[id] : id}
              </option>
            );
          })}
        </select>
        <label>Export Status</label>
        <select
          aria-label="select status"
          defaultValue={selectedStatus}
          onChange={({ target }) =>
            updateExportStatusHistoryQuery(target.value)
          }
        >
          <option disabled value="default">
            Choose status
          </option>
          <option value="all">All</option>
          <option value="complete">Complete</option>
          <option value="incomplete">Incomplete</option>
        </select>
      </SearchForm>

      <ToastContainer screenName="ExportHistorySearchForm" />
    </>
  );
};

const mapStateToProps = (state) => ({
  configurationIds: state.genericExportOptions.configurationIds,
  configurationNames: state.genericExportOptions.configurationNames,
  types: state.genericExportOptions.types,
  selectedDestination: state.exportHistoryOptions.selectedDestinationHistory,
  selectedStatus: state.exportHistoryOptions.selectedStatusHistory,
});

const mapDispatchToProps = (dispatch) => ({
  updateExportStatusHistoryQuery: (value) =>
    dispatch(updateExportStatusHistoryQuery(value)),
  updateExportDestinationHistoryQuery: (value) =>
    dispatch(updateExportDestinationHistoryQuery(value)),
});

const ConnectedExportHistorySearchForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(ExportHistorySearchForm);
export default ConnectedExportHistorySearchForm;
